var dataLayerDebugMode = document.currentScript.getAttribute('data-debug-mode') === 'true';

if (dataLayerDebugMode) {
    console.log('dataLayer-allPages - Debug mode: on');
}

function pushDataLayer(dataLayerEventName, productData) {
    if (dataLayerEventName && productData) {
        let ecommerce_data = {};

        ecommerce_data['currency'] = productData.gtmItemCurrency;
        ecommerce_data['value'] = productData.gtmItemPrice;
        ecommerce_data['item_list_name'] = productData.gtmItemListName;
        ecommerce_data['item_list_id'] = productData.gtmItemListId;
        ecommerce_data['items'] = [{
            'item_id': productData.gtmItemId,
            'item_name': productData.gtmItemName,
            'item_brand': productData.gtmItemBrand,
            'item_category': productData.gtmItemCategory,
            'item_category2': productData.gtmItemCategory2,
            'item_category3': productData.gtmItemCategory3,
            'price': productData.gtmItemPrice,
            'discount': '',
            'coupon': '',
            'currency': productData.gtmItemCurrency,
            'index': productData.gtmItemIndex,
            'item_sale_value': productData.gtmItemSaleValue,
            'item_sale': productData.gtmItemSale,
            'item_availability': productData.gtmItemAvailability,
            'affiliation': productData.gtmItemAffiliation,
            'item_variant': productData.gtmItemVariant,
            'item_sku': productData.gtmItemSku,
            'quantity': productData.gtmItemQuantity
        }];

        Shopify.analytics.publish('raise-custom-event', {
            'event': dataLayerEventName,
            'ecommerce': ecommerce_data
        });


        if (dataLayerDebugMode) {
            console.log('dataLayer debug - ' + dataLayerEventName + ': ' , ecommerce_data);
        }
    }
}

/** DATALAYER: Add to wishlist **/
document.querySelectorAll('.iWishAddColl').forEach(element => element.addEventListener('click', (event) => {
    if (dataLayerDebugMode) {
        console.log('PDP/Listing add to wishlist');
    }

    let eventTargetProductItem = event.target.closest('div.card-wrapper');
    const eventName = event.target.classList.contains('iwishAdded') ? 'remove_from_wishlist' : 'add_to_wishlist'
    if (
        eventTargetProductItem &&
        eventTargetProductItem.getAttribute('data-product-info')
    ) {
        productData = JSON.parse(eventTargetProductItem.getAttribute('data-product-info'));
        productData.gtmItemVariant = '';

        pushDataLayer(eventName, productData);
    }
  })
);

 document.addEventListener('DOMContentLoaded', function() {
    if (window.location.href.includes('?login-success')) {
        let login_data = {
            'event': 'login',
            'method': 'website',
            'user_id': __st.cid
        };

        dataLayer.push(login_data);

        if(Antonioli.customerId != ''){
            dataLayer.push({
              'user_id': Antonioli.customerId
            })
        };

        if (dataLayerDebugMode) {
            console.log('dataLayer debug - login: ', login_data);
        }

    } else if (window.location.href.includes('?sign-up-success')) {
        let sign_up_data = {
            'event': 'sign_up',
            'method': 'website',
            'user_id': __st.cid
        };

        dataLayer.push(sign_up_data);

        if(Antonioli.customerId != ''){
            dataLayer.push({
              'user_id': Antonioli.customerId
            })
        };

        if (dataLayerDebugMode) {
            console.log('dataLayer debug - sign_up: ', sign_up_data);
        }
    }
});
